"use client";

import type React from "react";
import { GuestFavoritesMergeManager } from "@/components/favorites/guest-favorites-merge-manager";
import { SWRProvider } from "@/components/providers/swr-provider";
import { GlobalDataProvider } from "@/contexts/global-data-context";

export function Providers({ children }: { children: React.ReactNode }) {
	return (
		<SWRProvider>
			<GlobalDataProvider>
				{children}
				<GuestFavoritesMergeManager />
			</GlobalDataProvider>
		</SWRProvider>
	);
}
